(function () {
  var COOKIE_NAME = 'location_popup_seen';
  // Session-only marker (no expiry) for a visitor who closed the popup
  // without choosing. It keeps the popup away for the rest of this visit
  // and lets it ask again on the next one. Only a real choice (one of the
  // buttons) sets COOKIE_NAME for the long "don't ask again" period.
  var DISMISSED_COOKIE = 'location_popup_dismissed';

  // Where the law requires opt-in consent: the EU/EEA (incl. Norway,
  // Iceland, Liechtenstein), the UK and Switzerland. Used ONLY as a fallback
  // when Shopify's own privacy API cannot answer in time - see
  // decideNeedsConsent() below.
  var CONSENT_COUNTRIES = [
    'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE',
    'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE',
    'NO', 'IS', 'LI', 'GB', 'CH'
  ];
  var SELECTOR = 'modal-dialog[data-location-popup]';
  var editorSelected = false;

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
  }

  function removeStaleModals(keep) {
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      if (el !== keep) el.remove();
    });
  }

  // Every one of the shop's own Markets domains. Used below to tell apart
  // the two situations that both show up as a bare `shpxid=` marker in
  // the URL -- see arrivedViaMarketRedirect() / arrivedFromOwnDomain().
  var SHOP_HOSTNAMES = ['lofotenseaweed.com', 'lofotenseaweed.eu', 'lofotenseaweed.no'];

  function arrivedViaMarketRedirect() {
    return /(?:^|[?&])shpxid=/.test(window.location.search);
  }

  function arrivedFromOwnDomain() {
    if (!document.referrer) return false;
    try {
      var referrerHost = new URL(document.referrer).hostname.replace(/^www\./, '');
      return SHOP_HOSTNAMES.indexOf(referrerHost) !== -1;
    } catch (e) {
      return false;
    }
  }

  // 2026-10-13: a cookie choice made on one of our domains does NOT travel
  // to another. Shopify keeps it in a cookie per domain, and browsers never
  // share cookies between lofotenseaweed.com / .no / .eu. Tested live: a
  // visitor in Norway accepted on .com, picked Norway, landed on .no - the
  // popup stayed away (see below) and .no recorded nothing at all. So the
  // choice now rides along in the address Shopify sends them back to
  // (?ls_consent=all|essential) and is re-applied on arrival.
  var CONSENT_PARAM = 'ls_consent';

  function readConsentParam() {
    var match = window.location.search.match(/(?:^|[?&])ls_consent=(all|essential)(?:&|$)/);
    return match ? match[1] : null;
  }

  function stripConsentParam() {
    if (!window.history || typeof window.history.replaceState !== 'function') return;
    try {
      var url = new URL(window.location.href);
      if (!url.searchParams.has(CONSENT_PARAM)) return;
      url.searchParams.delete(CONSENT_PARAM);
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    } catch (e) {
      /* cosmetic only */
    }
  }

  function withConsentParam(path, choice) {
    try {
      var url = new URL(path || '/', window.location.origin);
      url.searchParams.set(CONSENT_PARAM, choice);
      return url.pathname + url.search + url.hash;
    } catch (e) {
      return path;
    }
  }

  function consentFor(choice) {
    var granted = choice === 'all';
    return { analytics: granted, marketing: granted, preferences: granted, sale_of_data: granted };
  }

  // True only when this visitor must be asked AND has no answer stored on
  // this domain. Checked on the live store 2026-10-13: shouldShowBanner()
  // only says whether the REGION needs a banner - it stays true after the
  // visitor has accepted - so the stored answer has to be checked too.
  // Used only to override a "don't show" decision, never to suppress one.
  function stillUnanswered(cp) {
    if (!cp) return false;
    try {
      if (cp.shouldShowBanner() !== true) return false;
      if (typeof cp.currentVisitorConsent === 'function') {
        var c = cp.currentVisitorConsent() || {};
        return !c.analytics && !c.marketing && !c.preferences;
      }
      if (typeof cp.getTrackingConsent === 'function') {
        return cp.getTrackingConsent() === 'no_interaction';
      }
    } catch (e) {
      /* treat as answered */
    }
    return false;
  }

  function prefillDetectedCountry(modal) {
    var select = modal.querySelector('select[name="country_code"]');
    if (!select || !window.Shopify || !window.Shopify.routes || !window.Shopify.routes.root) return;

    var servedCode = select.value;

    var url = window.Shopify.routes.root + 'browsing_context_suggestions.json?country[enabled]=true';

    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (data) {
        var detected =
          data &&
          data.detected_values &&
          data.detected_values.country &&
          data.detected_values.country.handle;
        if (!detected || detected === servedCode) return;

        if (select.value !== servedCode) return;

        var option = select.querySelector('option[value="' + detected + '"]');
        if (!option) return;

        select.value = detected;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      })
      .catch(function () {
        /* leave the served country selected */
      });
  }

  function setupCountryCombobox(modal, form) {
    var select = form.querySelector('select[name="country_code"]');
    var selectWrap = select && select.closest('.location-popup-modal__select-wrap');
    var field = selectWrap && selectWrap.closest('.location-popup-modal__field');
    if (!select || !selectWrap || !field) return;

    var options = Array.prototype.map.call(select.querySelectorAll('option'), function (option) {
      return { value: option.value, label: option.textContent.trim() };
    });
    if (options.length < 8) return;

    function labelFor(value) {
      var match = options.filter(function (opt) {
        return opt.value === value;
      })[0];
      return match ? match.label : '';
    }

    function valueForLabel(label) {
      var needle = label.trim().toLowerCase();
      var match = options.filter(function (opt) {
        return opt.label.toLowerCase() === needle;
      })[0];
      return match ? match.value : null;
    }

    var listId = 'PopupCountryList-' + (modal.dataset.sectionId || 'popup');

    var datalist = document.createElement('datalist');
    datalist.id = listId;
    options.forEach(function (opt) {
      var dOption = document.createElement('option');
      dOption.value = opt.label;
      datalist.appendChild(dOption);
    });

    var visibleLabel = field.querySelector('label');

    var input = document.createElement('input');
    input.type = 'text';
    input.className = select.className;
    input.setAttribute('list', listId);
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('spellcheck', 'false');
    if (visibleLabel && visibleLabel.id) input.setAttribute('aria-labelledby', visibleLabel.id);
    input.placeholder = modal.dataset.filterPlaceholder || 'Type or choose a country';
    input.value = labelFor(select.value);

    input.addEventListener('focus', function () {
      input.value = '';
    });

    // 2026-10-13: Chromium only drops a datalist down when an ALREADY
    // focused field is clicked (or via its arrow, which is hidden above), so
    // the first click merely focused the field and a second click was needed.
    // showPicker() opens the list on the first click. It needs the click's
    // user activation, may be missing (older browsers) or throw (Safari,
    // already open), hence the guard - the field still works by typing.
    input.addEventListener('click', function () {
      if (typeof input.showPicker !== 'function') return;
      try {
        input.showPicker();
      } catch (error) {
        /* typing and the second click still work */
      }
    });

    input.addEventListener('input', function () {
      var matched = valueForLabel(input.value);
      if (matched && matched !== select.value) {
        select.value = matched;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    input.addEventListener('blur', function () {
      input.value = labelFor(select.value);
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') event.preventDefault();
    });

    select.addEventListener('change', function () {
      input.value = labelFor(select.value);
    });

    select.style.display = 'none';
    select.setAttribute('aria-hidden', 'true');
    select.tabIndex = -1;
    selectWrap.insertBefore(input, select);
    selectWrap.appendChild(datalist);
  }

  // 2026-10-13: Shopify does NOT attach window.Shopify.customerPrivacy by
  // itself - it appears only when something asks for it. Checked on the
  // live store: after 4 s it was still missing, and one
  // Shopify.loadFeatures() call attached it at once. Until now this file
  // only waited for it, so whenever nothing else had loaded it, a click on
  // "accept" submitted the form WITHOUT recording consent and the visitor
  // stayed untracked. We now request it explicitly (Shopify's documented
  // way), and still poll in case another script loads it first.
  function getCustomerPrivacy() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    return cp && typeof cp.shouldShowBanner === 'function' ? cp : null;
  }

  var privacyRequested = false;
  function requestCustomerPrivacy() {
    if (privacyRequested || getCustomerPrivacy()) return;
    privacyRequested = true;
    try {
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {});
      }
    } catch (e) {
      /* polling below still picks it up if something else loads it */
    }
  }

  function waitForCustomerPrivacy(callback, timeoutMs) {
    requestCustomerPrivacy();
    var deadline = Date.now() + (timeoutMs || 3000);
    (function poll() {
      var cp = getCustomerPrivacy();
      if (cp) {
        callback(cp);
        return;
      }
      if (Date.now() >= deadline) {
        callback(null);
        return;
      }
      window.setTimeout(poll, 50);
    })();
  }

  // Who gets the two cookie buttons, and who just gets "Update".
  //
  // 2026-10-12: Shopify's own answer now decides. Shopify asks for consent
  // where the law requires it (EU/EEA, UK, Switzerland ...) and for anyone
  // who has not answered yet there; elsewhere - the US, for example - it
  // reports that no banner is needed and tracks by default. Between the
  // 17 September hotfix and this change, every visitor was asked unless
  // Shopify explicitly said otherwise, which cost tracking for US visitors
  // who closed the popup or picked "essential only" without having to.
  //
  // When Shopify's API is missing, slow or throws, we still do NOT fall back
  // to "don't ask" everywhere (the failure the hotfix fixed): we ask when the
  // store country is in an opt-in-consent country, or unknown, and skip only
  // for countries that are clearly outside that list.
  function decideNeedsConsent(cp) {
    if (cp) {
      try {
        var answer = cp.shouldShowBanner();
        if (answer === true) return true;
        if (answer === false) return false;
      } catch (e) {
        /* fall through to the country fallback */
      }
    }
    var country = window.Shopify && window.Shopify.country;
    if (!country) return true;
    return CONSENT_COUNTRIES.indexOf(String(country).toUpperCase()) !== -1;
  }

  function setupLocationAndConsentActions(modal, form) {
    var consentGroup = form.querySelector('[data-location-popup-consent-actions]');
    var simpleButton = form.querySelector('[data-location-popup-simple-action]');
    var manageLink = form.querySelector('[data-location-popup-manage-cookies]');

    function submitForm() {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
    }

    // In the theme editor, always show the two cookie buttons so they can be
    // previewed and styled. The editor has no real visitor's consent state,
    // and the admin's own earlier answer would otherwise swap them for the
    // plain "Update" button. No API request and no wait in the editor.
    var inEditor = document.documentElement.classList.contains('shopify-design-mode');
    var whenPrivacyReady = inEditor
      ? function (callback) {
          callback(null);
        }
      : waitForCustomerPrivacy;

    whenPrivacyReady(function (cp) {
      // This is our ONLY cookie prompt on the site — the native Shopify
      // banner is hidden unconditionally whenever this section renders
      // (see the CSS comment at the top of this section's style block),
      // so if we don't ask here, nobody ever asks. That makes the choice
      // of fallback when Shopify's own privacy script can't be reached in
      // time (slow network, a blocked script, Tor, certain browser
      // privacy tooling, or theme-preview mode, which never loads it at
      // all) genuinely consequential, not a cosmetic default.
      //
      // The previous version defaulted to "no need to ask" whenever cp
      // was unavailable or threw. Combined with the fact that clicking
      // the resulting plain "Update" button sets our own 90-day
      // "don't show this popup again" cookie, a single unlucky visit —
      // one slow load, one blocked script — could leave a visitor who
      // genuinely needed to be asked uncounted for three months, with no
      // fallback banner to catch them since ours is the only one shown.
      //
      // Flipped here: only an EXPLICIT `false` from Shopify's own API
      // counts as "this visitor is already covered" (e.g. already
      // decided on an earlier visit, or a privacy signal Shopify itself
      // chose to honor as an opt-out). Anything else — the API never
      // showing up, throwing, or returning something unexpected — now
      // defaults to asking. Worst case with this default, a visitor who
      // already answered gets asked once more and re-confirms in one
      // click; worst case with the old default was never truly asking a
      // visitor who was supposed to be asked at all.
      var needsConsent = inEditor ? true : decideNeedsConsent(cp);

      if (needsConsent && consentGroup) {
        consentGroup.hidden = false;
        if (simpleButton) simpleButton.hidden = true;
      } else if (simpleButton) {
        simpleButton.hidden = false;
        if (consentGroup) consentGroup.hidden = true;
      }
    });

    if (consentGroup) {
      consentGroup.querySelectorAll('[data-location-popup-consent]').forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();

          var choice = button.getAttribute('data-location-popup-consent') === 'all' ? 'all' : 'essential';
          var consent = consentFor(choice);

          // Carry the choice to wherever Shopify sends them next: if the
          // picked country lives on another of our domains, the consent
          // recorded here does not exist there (see CONSENT_PARAM above).
          var returnTo = form.querySelector('input[name="return_to"]');
          if (returnTo) {
            returnTo.value = withConsentParam(
              returnTo.value || window.location.pathname + window.location.search,
              choice
            );
          }

          // Record the choice before the form navigates away. If the API
          // is not attached yet (a very quick click), wait for it briefly;
          // if Shopify never calls back, submit anyway after a moment so
          // the visitor is never stuck on an unresponsive popup.
          var submitted = false;
          function submitOnce() {
            if (submitted) return;
            submitted = true;
            submitForm();
          }
          waitForCustomerPrivacy(function (cp) {
            if (cp && typeof cp.setTrackingConsent === 'function') {
              try {
                cp.setTrackingConsent(consent, submitOnce);
                window.setTimeout(submitOnce, 2500);
                return;
              } catch (e) {
                /* fall through */
              }
            }
            submitOnce();
          }, 3000);
        });
      });
    }

    if (manageLink) {
      manageLink.addEventListener('click', function (event) {
        event.preventDefault();
        if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
          window.privacyBanner.showPreferences();
        }
      });
    }
  }

  function bind(modal) {
    if (!modal || modal.dataset.locationPopupBound || typeof modal.show !== 'function') return;
    modal.dataset.locationPopupBound = 'true';

    var rememberDays = parseInt(modal.dataset.remember, 10) || 180;
    var delay = parseInt(modal.dataset.delay, 10) || 0;

    // A real choice (accept all, essential only, or plain "Update"): don't
    // ask again for rememberDays. "Essential only" is remembered exactly
    // like "accept" - re-asking someone who refused would be pressuring
    // them (EDPB "overloading"); they can change it via Manage cookie
    // settings.
    var chosen = false;
    function remember() {
      chosen = true;
      setCookie(COOKIE_NAME, '1', rememberDays);
    }

    // Closed without a choice (X, Esc, or a click outside the card): no
    // consent is given, nothing long-lived is stored, and the popup comes
    // back on the next visit - not on every page of this one.
    function markDismissed() {
      if (chosen) return;
      setCookie(DISMISSED_COOKIE, '1');
    }

    // Dawn's modal-dialog closes itself on Esc and on a backdrop click via
    // hide(); wrap it so every way of closing is treated the same.
    if (!document.documentElement.classList.contains('shopify-design-mode')) {
      var originalHide = modal.hide.bind(modal);
      modal.hide = function () {
        markDismissed();
        return originalHide.apply(null, arguments);
      };
    }

    modal.querySelectorAll('[data-location-popup-dismiss]').forEach(function (button) {
      button.addEventListener('click', function () {
        modal.hide();
      });
    });

    var form = modal.querySelector('.location-popup-modal__form');
    if (form) {
      form.addEventListener('submit', remember);
      setupLocationAndConsentActions(modal, form);
      setupCountryCombobox(modal, form);
    }

    if (document.documentElement.classList.contains('shopify-design-mode')) {
      if (editorSelected) modal.show();
      return;
    }

    var carriedChoice = readConsentParam();
    if (carriedChoice) stripConsentParam();

    var chosenBefore = !!getCookie(COOKIE_NAME);
    var redirectedByUs = arrivedViaMarketRedirect() && arrivedFromOwnDomain();

    if (carriedChoice || chosenBefore || redirectedByUs) {
      // The visitor has made their choice - on this domain earlier, or on
      // another of ours a moment ago. Don't ask again IF this domain knows
      // it. If Shopify here still reports "unanswered", re-apply a carried
      // choice silently; otherwise (lost on the way, or never saved - the
      // live popup could submit without recording consent before
      // 2026-10-13) ask once more rather than leave them untracked.
      waitForCustomerPrivacy(function (cp) {
        if (!stillUnanswered(cp)) {
          remember();
          return;
        }
        if (carriedChoice && typeof cp.setTrackingConsent === 'function') {
          try {
            cp.setTrackingConsent(consentFor(carriedChoice), function () {});
            remember();
            return;
          } catch (e) {
            /* fall through and ask */
          }
        }
        prefillDetectedCountry(modal);
        window.setTimeout(function () {
          modal.show();
        }, delay);
      }, 3000);
      return;
    }

    if (getCookie(DISMISSED_COOKIE)) return;

    // Shopify's cross-domain Markets redirect (the `shpxid=` marker) fires
    // in two situations that look identical from the query string alone:
    //
    //   1. A visitor explicitly picked a country or language -- via this
    //      popup's own form, or the header's country selector -- and that
    //      choice happens to live on a different market domain (e.g.
    //      picking Germany while on lofotenseaweed.com bounces them to
    //      lofotenseaweed.eu). They already made their choice; asking
    //      again the instant they land is exactly the double-ask we don't
    //      want.
    //   2. A visitor's FIRST-EVER contact with the shop -- direct
    //      navigation, a search result, an ad link, a fresh Tor circuit --
    //      gets auto-redirected by Shopify's own geolocation before they
    //      ever see a page, with no chance to answer anything.
    //
    // Our "seen" cookie is per-domain and doesn't travel with a
    // cross-domain redirect, so shpxid alone can't tell these two apart.
    // document.referrer can: case 1 always arrives FROM one of our own
    // domains (they were just on that page, in this tab, an instant ago),
    // case 2 arrives from an external referrer or none at all (a fresh
    // Tor circuit typically sends no referrer either). We only skip
    // showing the popup for case 1 -- an already-made choice -- and still
    // ask in case 2.
    // (Arrivals via our own cross-domain redirect are handled above.)

    prefillDetectedCountry(modal);

    window.setTimeout(function () {
      modal.show();
    }, delay);
  }

  function refresh() {
    var modals = document.querySelectorAll(SELECTOR);
    if (!modals.length) return;
    var latest = modals[modals.length - 1];
    removeStaleModals(latest);
    bind(latest);
  }

  // Every OTHER country/language switcher (header, footer, drawer) posts
  // Shopify's localization form too, and can send the visitor to another of
  // our domains just the same - where their consent does not exist. Stamp
  // the visitor's current answer into each such form's return_to, so the
  // arrival logic in bind() can re-apply it there. Dawn submits these forms
  // with form.submit() (no submit event), so they are stamped up front and
  // again whenever the answer changes, rather than at submit time.
  function currentChoice(cp) {
    if (!cp) return null;
    try {
      if (typeof cp.currentVisitorConsent === 'function') {
        var c = cp.currentVisitorConsent() || {};
        var keys = ['analytics', 'marketing', 'preferences'];
        var yes = keys.every(function (k) { return c[k] === 'yes'; });
        var no = keys.every(function (k) { return c[k] === 'no'; });
        if (yes) return 'all';
        if (no) return 'essential';
        return null; // undecided or a mixed choice: let the next domain ask
      }
      if (typeof cp.getTrackingConsent === 'function') {
        var t = cp.getTrackingConsent();
        if (t === 'yes') return 'all';
        if (t === 'no') return 'essential';
      }
    } catch (e) {
      /* nothing to carry */
    }
    return null;
  }

  function stampLocalizationForms(cp) {
    var choice = currentChoice(cp || getCustomerPrivacy());
    if (!choice) return;
    document.querySelectorAll('form[action*="/localization"] input[name="return_to"]').forEach(function (input) {
      input.value = withConsentParam(input.value || window.location.pathname + window.location.search, choice);
    });
  }

  function initConsentCarry() {
    if (document.documentElement.classList.contains('shopify-design-mode')) return;
    waitForCustomerPrivacy(stampLocalizationForms, 5000);
    document.addEventListener('visitorConsentCollected', function () {
      stampLocalizationForms();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
    document.addEventListener('DOMContentLoaded', initConsentCarry);
  } else {
    refresh();
    initConsentCarry();
  }

  document.addEventListener('shopify:section:load', refresh);

  document.addEventListener('shopify:section:select', function (event) {
    var modal = document.querySelector(SELECTOR);
    if (!modal || event.detail.sectionId !== modal.dataset.sectionId) return;
    editorSelected = true;
    modal.show();
  });

  document.addEventListener('shopify:section:deselect', function (event) {
    var modal = document.querySelector(SELECTOR);
    if (!modal || event.detail.sectionId !== modal.dataset.sectionId) return;
    editorSelected = false;
    modal.hide();
  });
})();
